import { render, staticRenderFns } from "./DeleteFaq.vue?vue&type=template&id=290b4644"
import script from "./DeleteFaq.vue?vue&type=script&lang=js"
export * from "./DeleteFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports